/**
 * EventCard component.
 */
import Card from '@shared/types/props/card';
import HorizontalCard from './horizontalCard';
import useList from '@shared/components/utils/hooks/useList';
import Colors from '@shared/assets/style/default/color';
import { useMemo } from 'react';

/**
 * Number of items to display in the event rail.
 */
const ITEMS_TO_DISPLAY = 5;

/**
 * Event card component.
 */
export default function EventCard({
  item,
  index,
  onClick,
  releaseAction,
}: Card) {
  const { distanceToIndex } = useList(index);
  const progressBar = useMemo(() => {
    const canDisplay =
      distanceToIndex < ITEMS_TO_DISPLAY && distanceToIndex > -ITEMS_TO_DISPLAY;
    const currentEvent = item.isCurrentEvent() && !item.mocked;
    if (!canDisplay || !currentEvent) return undefined;

    const progress = item.date ? Date.now() - item.date.start : undefined;
    const duration = item.date ? item.date.end - item.date.start : undefined;
    const percentage = Math.max(
      progress && duration ? (progress / duration) * 100 : 0,
      0
    );
    return {
      color: Colors.progress.fill,
      percentage: currentEvent && percentage > 0 ? percentage : 0,
    };
  }, [distanceToIndex, item]);

  return (
    <HorizontalCard
      index={index}
      item={item}
      progressBar={progressBar}
      releaseAction={onClick || releaseAction}
    />
  );
}
